export default "__VITE_ASSET__BMf3X3eD__"